class Document {
  constructor(data) {
    this.document = data.document;
    this.name = data.document_name;
    this.extension = data.document_extension;
    this.date = data.created_at;
    this.uploadedBy = data.user.first_name + ' ' + data.user.last_name;
    this.pk = data.pk;
    this.isActive = data.is_active;
    this.documentType = data.document_type;
    this.documentSubType = data.document_sub_type;
    this.imageThumbnailsOriginal = data.image_thumbnails?.original?.url;
    this.imageThumbnailsSmall = data.image_thumbnails?.small?.url;
  }
}
export default Document;